<template>
    <section class="content">
        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1>Catalogo</h1>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                            <li class="breadcrumb-item active">Catalogo</li>
                        </ol>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 col-sm-6 col-md-4">
                    <div id="btn-agregar-proveedor" class="info-box mb-3" @click="abrirModal('proveedor')" data-target="#proveedorModal"
                        data-toggle="modal">
                        <a href="javascript:void(0)" class="btn btn-block info-box-icon bg-info elevation-1"><i
                                class="fas fa-plus"></i></a>
                        <div class="info-box-content">
                            <span class="info-box-text">Proveedor</span>
                            <span class="info-box-number">Agregar</span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4" @click="abrirModal('categoria')" data-target="#categoriaModal"
                    data-toggle="modal">
                    <div id="btn-agregar-categoria" class="info-box mb-3">
                        <a href="javascript:void(0)" class="btn btn-block info-box-icon bg-success elevation-1"><i
                                class="fas fa-plus"></i></a>
                        <div class="info-box-content">
                            <span class="info-box-text">Categoria</span>
                            <span class="info-box-number">Agregar</span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4" data-toggle="modal" data-target="#productoModal"
                    @click="abrirModal2()">
                    <div id="btn-agregar-producto" class="info-box mb-3">
                        <a href="javascript:void(0)" class="btn btn-block info-box-icon bg-warning elevation-1"><i
                                class="fas fa-plus"></i></a>
                        <div class="info-box-content">
                            <span class="info-box-text">Producto</span>
                            <span class="info-box-number">Agregar</span>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-4">
                  <div
                    id="btn-descargar-pdf"
                    class="info-box mb-3"
                    @click="descargarPDF()"
                    style="cursor: pointer;"
                  >
                    <a href="javascript:void(0)" class="btn btn-block info-box-icon bg-danger elevation-1">
                      <i class="fas fa-file-pdf"></i>
                    </a>
                    <div class="info-box-content">
                      <span class="info-box-text">Reporte</span>
                      <span class="info-box-number">Descargar PDF</span>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="row align-items-center">
                                <div class="col">
                                    <h3 class="card-title">Lista de productos</h3>
                                </div>
                                <div class="col-auto">
                                    <div class="container-fluid mb-3">
                                        <div class="dropdown d-inline-block">
                                            <button ref="toggleFiltros" class="btn btn-info dropdown-toggle"
                                                type="button" id="ddlFiltros" data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                <i class="fas fa-filter"></i> Filtros
                                            </button>
                                            <div class="dropdown-menu p-3 dropdown-menu-right"
                                                aria-labelledby="ddlFiltros" style="min-width: 280px;" @click.stop>
                                                <div class="form-group">
                                                    <label>Proveedor</label>
                                                    <select v-model="proveedorSeleccionado" @change="filtrarProductos"
                                                        class="form-control mr-3">
                                                        <option value="">Todos los proveedores</option>
                                                        <option v-for="proveedor in proveedores" :key="proveedor.id"
                                                            :value="proveedor.id">
                                                            {{ proveedor.descripcion }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>Categoria</label>
                                                    <select v-model="categoriaSeleccionada" @change="filtrarProductos"
                                                        class="form-control mr-3">
                                                        <option value="">Todas las categorías</option>
                                                        <option v-for="categoria in categoriasFiltradas"
                                                            :key="categoria.id" :value="categoria.id">
                                                            {{ categoria.descripcion }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="form-group">
                                                    <label>Tipo de Venta</label>
                                                    <select v-model="ventaSeleccionada" @change="filtrarProductos"
                                                        class="form-control mr-3">
                                                        <option value="">Todos</option>
                                                        <option value="ambos">Caja y Unidad</option>
                                                        <option value="caja">Solo Caja</option>
                                                        <option value="unidad">Solo Unidad</option>
                                                    </select>
                                                </div>
                                                <div class="d-flex justify-content-between mt-2">
                                                    <button class="btn btn-sm btn-outline-secondary"
                                                        @click="limpiarFiltros()">
                                                        Limpiar
                                                    </button>
                                                    <button class="btn btn-sm btn-primary"
                                                        @click="$refs.toggleFiltros.click()">
                                                        Cerrar
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- /.card-header -->
                        <div class="card-body">
                            <table id="tablaProductos" class="table table-bordered table-striped">
                                <thead>
                                    <tr>
                                        <th>Codigo</th>
                                        <th>Categoria</th>
                                        <th>Descripcion</th>
                                        <th>Precio UN.</th>
                                        <th>IVA UN.</th>
                                        <th>Precio CJ.</th>
                                        <th>Opciones</th>
                                    </tr>
                                </thead>
                            </table>
                            <FormProducto :producto="productoSeleccionado" :categorias="categorias"
                                @success="obtenerProductos" />
                            <FormProveedor :proveedor="proveedorSeleccionadoParaForm" :empresas="empresas"
                                @success="obtenerProveedores" />
                            <FormCategorias :categoria="categoriaSeleccionadaParaForm" :proveedores="proveedores"
                                @success="obtenerCategorias" />
                        </div>
                        <!-- /.card-body -->
                    </div>
                    <!-- /.card -->
                </div>
                <!-- /.col -->
            </div>
            <!-- /.row -->
        </div>
        <!-- /.container-fluid -->
    </section>
    <!-- /.content -->
</template>

<script>
import { ref, computed, onMounted, onBeforeUnmount, watch, nextTick, getCurrentInstance } from "vue";
import api from "@/services/api";
import FormProducto from "@/components/FormProducto.vue";
import FormProveedor from "@/components/FormProveedor.vue";
import FormCategorias from "@/components/FormCategorias.vue";
import { tutorial } from "@/plugins/tutorial";
import { loading } from '@/plugins/loading';
import { alert } from '@/plugins/alert';
import debounce from "lodash/debounce";

export default {
    components: { FormProducto, FormProveedor, FormCategorias },
    setup() {
        const productos = ref([]);
        const categorias = ref([]);
        const proveedores = ref([]);
        const empresas = ref([]);
        const productoSeleccionado = ref(null);
        const proveedorSeleccionadoParaForm = ref(null);
        const categoriaSeleccionadaParaForm = ref(null);
        const modalTipo = ref("");
        const modalActivo = ref(false);
        const proveedorSeleccionado = ref("");
        const categoriaSeleccionada = ref("");
        const ventaSeleccionada = ref("");
        const dtInstance = ref(null);
        const { proxy } = getCurrentInstance();
        const apiBaseURL = api.defaults.baseURL;

        // 1) Computed categories → proveedor
        const categoriasFiltradas = computed(() => {
            if (!proveedorSeleccionado.value) return categorias.value;
            return categorias.value.filter(
                c => c.proveedor_id === +proveedorSeleccionado.value
            );
        });

        // 2) Computed inventarios filtrados
        const productosFiltrados = computed(() => {
            const catIds = new Set(categoriasFiltradas.value.map(c => c.id));
            return productos.value.filter(item => {
                if (
                    proveedorSeleccionado.value &&
                    !catIds.has(item.categoria_id)
                ) return false;
                if (
                    categoriaSeleccionada.value &&
                    item.categoria_id !== +categoriaSeleccionada.value
                ) return false;
                if (ventaSeleccionada.value) {
                    const vendeAmbos = item.vende_caja && item.vende_unidad;
                    if (ventaSeleccionada.value === 'ambos' && !vendeAmbos) return false;
                    if (ventaSeleccionada.value === 'caja' && (!item.vende_caja || item.vende_unidad)) return false;
                    if (ventaSeleccionada.value === 'unidad' && (!item.vende_unidad || item.vende_caja)) return false;
                }

                return true;
            });
        });

        async function obtenerProductos() {
            try {
                const { data } = await api.get("/producto");
                productos.value = data;
                console.log("Productos obtenidos:", data);
            } catch (e) {
                console.error("Error al obtener productos:", e);
            }
        }

        async function obtenerCategorias() {
            try {
                const { data } = await api.get("/categoria");
                categorias.value = data;
            } catch (e) {
                console.error("Error al obtener categorías:", e);
            }
        }

        async function obtenerProveedores() {
            try {
                const { data } = await api.get("/proveedor");
                proveedores.value = data;
            } catch (e) {
                console.error("Error al obtener proveedores:", e);
            }
        }

        async function obtenerEmpresas() {
            try {
                const { data } = await api.get("/empresa");
                empresas.value = data;
            } catch (e) {
                console.error("Error al obtener empresas:", e);
            }
        }

        function abrirModal(tipo, item = null) {
            modalTipo.value = tipo;
            if (tipo === 'proveedor') {
                proveedorSeleccionadoParaForm.value = item ? { ...item } : null;
                nextTick(() => window.$("#proveedorModal").modal("show"));
            } else if (tipo === 'categoria') {
                categoriaSeleccionadaParaForm.value = item ? { ...item } : null;
                nextTick(() => window.$("#categoriaModal").modal("show"));
            }
        }

        function abrirModal2(producto = null) {
            productoSeleccionado.value = producto ? { ...producto } : null;
            modalTipo.value = "producto";
            modalActivo.value = true;
        }
        function confirmarBorrado(id) {
          const prod = productos.value.find(p => p.id === id);
          proxy.$alert({
            title: '¿Seguro?',
            text: `No podrás revertir la eliminación de: ${prod ? prod.descripcion : 'este producto'}`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, bórralo'
          }).then(async res => {
            if (res.isConfirmed) {
                await eliminarProducto(id);
            }
          });
        }

        async function descargarPDF() {
            try {
                loading.show('Generando PDF...');
                const response = await api.get("/pdf/catalogo", { responseType: 'blob' });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Catalogo_Productos.pdf');
                document.body.appendChild(link);
                link.click();
                loading.hide();
            } catch (error) {
                loading.hide();
                alert.show({ title: 'Error', text: 'No se pudo generar el PDF', icon: 'error' });
            }
        }

        async function eliminarProducto(id) {
            try {
                loading.show('Eliminando producto...');
                await api.delete(`/producto/${id}`);
                proxy.$toast({ icon: 'success', title: '¡Eliminado correctamente!' });
                await obtenerProductos();
                reloadDataTable();
            } catch (e) {
                console.error("Error al eliminar producto:", e);
                const mensajeBackend = e.response?.data?.message || 'Error al eliminar';
                const detallesBackend = e.response?.data?.detalles || '';
                proxy.$toast({ 
                    icon: 'error', 
                    title: mensajeBackend,
                    text: detallesBackend,
                    timer: 6000 
                });
            }
        }
        function limpiarFiltros() {
            proveedorSeleccionado.value = ''
            categoriaSeleccionada.value = ''
            ventaSeleccionada.value = ''
        }

        function initDataTable() {
            const table = window.$("#tablaProductos").DataTable({
                data: productosFiltrados.value.map((p) => [
                    p.codigo,
                    p.categoria?.descripcion || "",
                    p.descripcion,
                    p.precunid,
                    p.porciva,
                    (((+p.precunid + +p.porciva) * +p.cantxcaja).toFixed(2)),
                    `<div class="d-flex justify-content-center">
             <button class="btn btn-warning px-3" data-id="${p.id}">
               <i class="fas fa-pen-to-square"></i>
             </button>
             <button class="btn btn-danger px-3 ms-1" data-id="${p.id}">
               <i class="fas fa-trash"></i>
             </button>
           </div>`
                ]),
                responsive: true,
                autoWidth: false,
                columnDefs: [
                    { responsivePriority: -1, targets: 0 },
                    { responsivePriority: 1, targets: 2 }
                ],
                pageLength: 10,
                lengthChange: false,
                pagingType: 'numbers',
                language: {
                    url: 'https://cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json'
                },
                dom: // 1ª fila: filtro (f) ocupa toda la anchura en móvil y la mitad en md+
                    '<"row mb-3"<"col-12 col-md-6"f>>' +
                    // tabla
                    't' +

                    // fila 1: info centrado
                    '<"row mt-3"<"col-12 text-center"i>>' +
                    // fila 2: paginación centrada
                    '<"row"<"col-12 d-flex justify-content-center"p>>',
            });

            // Delegación de eventos para editar y eliminar
            window.$("#tablaProductos tbody")
                .off("click") // limpia handlers previos
                .on("click", ".btn-warning", function () {
                    const id = window.$(this).data("id");
                    const prod = productos.value.find((x) => x.id == id);
                    if (prod) {
                        abrirModal2(prod);
                        window.$("#productoModal").modal("show");
                    }
                })
                .on("click", ".btn-danger", function () {
                    const id = window.$(this).data("id");
                    confirmarBorrado(id);
                });

            dtInstance.value = table;
        }

        function iniciarTutorial() {
            const steps = [
                {
                    element: '#btn-agregar-proveedor',
                    title: 'Nuevo Proveedor',
                    text: 'Haz clic aquí para registrar un nuevo proveedor.',
                    position: 'bottom'
                },
                {
                    element: '#btn-agregar-categoria',
                    title: 'Nueva Categoría',
                    text: 'Haz clic aquí para registrar una nueva categoría.',
                    position: 'bottom'
                },
                {
                    element: '#btn-agregar-producto',
                    title: 'Nuevo Producto',
                    text: 'Haz clic aquí para registrar un nuevo producto.',
                    position: 'bottom'
                },
                {
                    element: '#btn-descargar-pdf',
                    title: 'Descargar PDF',
                    text: 'Haz clic aquí para generar y descargar el catálogo de productos en formato PDF.',
                    position: 'bottom'
                },
                {
                    element: '#ddlFiltros',
                    title: 'Filtros',
                    text: 'Filtra la lista de productos por proveedor o categoría.',
                    position: 'left'
                },
                {
                    element: '.card-body',
                    title: 'Listado de Productos',
                    text: 'Aquí verás la lista de productos registrados.',
                    position: 'top'
                }
            ];

            const table = window.$('#tablaProductos');
            const isCollapsed = table.hasClass('collapsed');
            const actionsVisible = table.find('tbody tr:first-child td:last-child').is(':visible');

            if (isCollapsed && !actionsVisible) {
                const firstRow = table.find('tbody tr:first-child');

                if (firstRow.hasClass('parent')) {
                    const control = firstRow.find('.dtr-control');
                    if (control.length) control.click();
                    else firstRow.find('td:first-child').click();
                }

                steps.push({
                    element: '#tablaProductos tbody tr:first-child td:first-child',
                    title: 'Ver Detalles',
                    text: 'En pantallas pequeñas, haz clic en el símbolo (+) o en la primera columna para ver los datos ocultos y las acciones.',
                    position: 'bottom',
                    tooltipClass: 'hide-next-btn'
                });

                firstRow.off('click.tutorial');
                firstRow.on('click.tutorial', function () {
                    setTimeout(() => {
                        const tooltip = document.querySelector('.introjs-tooltip');
                        if (!tooltip) return;
                        if (window.$(this).hasClass('parent')) {
                            tooltip.classList.remove('hide-next-btn');
                        } else {
                            tooltip.classList.add('hide-next-btn');
                        }
                    }, 200);
                });

                steps.push({
                    element: '.dtr-details .btn-warning',
                    title: 'Editar Producto',
                    text: 'Haz clic en el botón amarillo para modificar los datos de un producto existente.',
                    position: 'left'
                });

                steps.push({
                    element: '.dtr-details .btn-danger',
                    title: 'Eliminar Producto',
                    text: 'Haz clic en el botón rojo para eliminar un producto. Esta acción requiere confirmación.',
                    position: 'left'
                });
            } else {
                steps.push({
                    element: '.btn-warning',
                    title: 'Editar Producto',
                    text: 'Haz clic en el botón amarillo para modificar los datos de un producto existente.',
                    position: 'left'
                });

                steps.push({
                    element: '.btn-danger',
                    title: 'Eliminar Producto',
                    text: 'Haz clic en el botón rojo para eliminar un producto. Esta acción requiere confirmación.',
                    position: 'left'
                });
            }

            tutorial.start(steps);
        }

        function reloadDataTable() {
            if (!dtInstance.value) return;
            const table = dtInstance.value;
            table.clear();
            table.rows.add(
                productosFiltrados.value.map((p) => [
                    p.codigo,
                    p.categoria?.descripcion || "",
                    p.descripcion,
                    p.precunid,
                    p.porciva,
                    (((+p.precunid + +p.porciva) * +p.cantxcaja).toFixed(2)),
                    `<div class="d-flex justify-content-center">
             <button class="btn btn-warning px-3" data-id="${p.id}">
               <i class="fas fa-pen-to-square"></i>
             </button>
             <button class="btn btn-danger px-3 ms-1" data-id="${p.id}">
               <i class="fas fa-trash"></i>
             </button>
           </div>`
                ])
            );
            table.draw(false);
        }

        const debouncedResize = debounce(() => {
            if (dtInstance.value) {
                dtInstance.value.columns.adjust().responsive.recalc();
            }
        }, 150);

        onMounted(async () => {
            await Promise.all([
                obtenerProductos(),
                obtenerCategorias(),
                obtenerProveedores(),
                obtenerEmpresas()
            ]);
            await nextTick();
            initDataTable();
            window.addEventListener("resize", debouncedResize);
            tutorial.set(iniciarTutorial);
        });

        watch(productosFiltrados, () => {
            reloadDataTable();
        });
        watch(proveedorSeleccionado, () => {
            categoriaSeleccionada.value = "";
        });

        onBeforeUnmount(() => {
            if (dtInstance.value) {
                dtInstance.value.destroy();
                dtInstance.value = null;
            }
            window.removeEventListener("resize", debouncedResize);
            tutorial.set(null);
        });

        return {
            productos,
            categorias,
            proveedores,
            empresas,
            productoSeleccionado,
            proveedorSeleccionadoParaForm,
            categoriaSeleccionadaParaForm,
            modalTipo,
            modalActivo,
            proveedorSeleccionado,
            categoriaSeleccionada,
            ventaSeleccionada,
            categoriasFiltradas,
            productosFiltrados,
            abrirModal,
            abrirModal2,
            descargarPDF,
            eliminarProducto,
            obtenerProductos,
            obtenerCategorias,
            obtenerProveedores,
            obtenerEmpresas,
            limpiarFiltros,
            apiBaseURL,
        };
    }
};
</script>
<style>
.hide-next-btn .introjs-nextbutton,
.hide-next-btn .introjs-nextBtn {
  display: none !important;
}
</style>